import { Box, Flex, Grid, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import logoSvg from '../../../../../assets/logo.svg'
import checkIcon from '../../../../../assets/checkIcon.png'
import { ConsumedEnergyIcon } from '../../../../../assets/icons/ConsumedEnergy'
import ProducedEnergyIcon from '../../../../../assets/icons/ProducedEnergyIcon'
import { KILOWATT_HOUR, CARBON_FOOTPRINT_KG, CARBON_INTENSITY, MONETARY_VALUE } from '../../../../../utils/consts'
import CloudIcon from '../../../../../assets/icons/CloudIcon'
import { formatDate, getLocationsPercentage } from '../../../../../utils/helpers'
import { EnergyConsumptionReport } from '../../../api/types'
import CarbonIntensityIcon from '../../../../../assets/icons/CarbonIntensity'
import CostForConsumptionIcon from '../../../../../assets/icons/CostConsumptionIcon'
import GeneratedIncomeIcon from '../../../../../assets/icons/GeneretedIncomeIcon'
import { CardPdf } from './CardComponentPdf'

type Props = {
  locations: EnergyConsumptionReport
  startDate: any
  data: any
  endDate: any
}

export const EnergyReportTitlePage = ({ locations, data, startDate, endDate }: Props) => {

  return (
    <Box
      border={'solid: 2px'}
      gap="60px"
      height="100%"
      width="100%"
      display="flex"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      pt={20}
    >
      <Flex direction="column" alignItems="center" gap={7}>
        <Flex direction="column" alignItems="center" gap={2}>
          <Stack height="fit-content">
            <Text
              fontSize="38px"
              fontWeight="700"
              fontFamily='Inter'
              color="#484848"
              align="center"
              m={0}
              p={0}
            >
              {`${formatDate(startDate)} - ${formatDate(endDate)}`}
            </Text>
          </Stack>
          <Text fontSize="20px" fontWeight={400} color="#484848" fontFamily="Inter">
            Energy Consumption Report
          </Text>
          <Flex gap={3} wrap="wrap" width="90%" justifyContent="center">
            {locations?.map((location) => (
              <Flex
                key={location.location_id}
                border="1px solid #157FEE"
                borderRadius="full"
                p="3px 20px"
                sx={{ bgcolor: 'red' }}
                bg="#E8EEFD"
                alignItems="center"
                justifyContent="center"
                m="0px"
              >
                <img
                  src={checkIcon}
                  alt="icon"
                  style={{ width: '20px', height: '20px', alignSelf: 'center' }}
                />
                <Text
                  className={'locationName'}
                  fontWeight="700"
                  fontSize="20px"
                  fontFamily="Inter"
                  color="#157FEE"
                >
                  {location.title}
                </Text>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <Flex direction="column" fontSize={20} fontWeight={700} gap={5} mb="160px">
        <Grid templateColumns="repeat(2, 300px)" gap={2}>
          <CardPdf
            width="100%"
            title="Total consumed energy"
            measurementType={KILOWATT_HOUR}
            value={data.currConsumption}
            percentageChange={getLocationsPercentage(data.currConsumption, data.prevConsumption)}
          >
            <ConsumedEnergyIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
          <CardPdf
            width="100%"
            title="Produced energy"
            measurementType={KILOWATT_HOUR}
            value={data.currGeneration}
            percentageChange={getLocationsPercentage(data.currGeneration, data.prevGeneration)}
          >
            <ProducedEnergyIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
          <CardPdf
            width="100%"
            title="Carbon footprint"
            measurementType={CARBON_FOOTPRINT_KG}
            value={data.currFootprint}
            percentageChange={getLocationsPercentage(data.currFootprint, data.prevFootprint)}
          >
            <CloudIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
          <CardPdf
            width="100%"
            title="Cost for consumption"
            measurementType={MONETARY_VALUE}
            value={data.currCost}
            percentageChange={getLocationsPercentage(data.currCost, data.prevCost)}
          >
            <CostForConsumptionIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
          <CardPdf
            width="100%"
            title="Generated income"
            measurementType={MONETARY_VALUE}
            value={data.currIncome}
            percentageChange={getLocationsPercentage(data.currIncome, data.prevIncome)}
          >
            <GeneratedIncomeIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
          <CardPdf
            width="100%"
            title="Carbon intensity"
            measurementType={CARBON_INTENSITY}
            value={data.intensity}
          >
            <CarbonIntensityIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
        </Grid>
      </Flex >
      <Stack mb="100px">
        <img src={logoSvg} alt="logo" />
      </Stack>
    </Box >
  )
}
